import template from './login.html';

let loginComponent = {
    templateUrl: template
};

export default loginComponent;


/** WEBPACK FOOTER **
 ** ./src/main/assets/app/login/login.component.js
 **/